import React, {
  useState,
  useContext,
} from 'react';

import AnnouncementContext from '../../../../context/AnnouncementContext';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import { ReactComponent as CreateIcon } from '../../../../../assets/icons/v2/creation-plus-circle.svg';
import { PrimaryButton } from '../../../../../components/Button/ActionButtons';
import {
  Title,
  HeaderRow,
  TitleContainer,
  SubTitle,
} from '../../../../../components/v2/Header';
import ToggleButtonGroup from '../../../../components/ToggleButtonGroup';

import { TabContainer } from '../../styles';
import AnnouncementModal from '../AnnouncementModal';
import AnnouncementList from '../AnnouncementList';
import SidebarFilter from '../SidebarFilter';
import FullPostView from '../FullPostView';
import { AnnouncementPublishTab } from './utils';

import {
  Container,
  StickyToggleBar,
  FilterAndFeedRow,
} from './styles';
import texts from './texts.json';

const Announcements = () => {
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);
  const {
    selectedAnnouncement,
    updateCommentAndAnnouncementState,
    isPinConfirmOpen,
    confirmPinReplace,
    cancelPinReplace,
    selectedPublishTab,
    setSelectedPublishTab,
    scheduledCount,
  } = useContext(AnnouncementContext);

  const publishTabOptions = [
    { value: AnnouncementPublishTab.PUBLISHED, label: texts.tabs.published },
    {
      value: AnnouncementPublishTab.SCHEDULED,
      label: scheduledCount > 0 ? `${texts.tabs.scheduled} (${scheduledCount})` : texts.tabs.scheduled,
    },
  ];

  return (
    <TabContainer>
      <Container>
        <HeaderRow>
          <TitleContainer>
            <Title>{texts.title}</Title>
            <SubTitle>{texts.subTitle}</SubTitle>
          </TitleContainer>
          <PrimaryButton onClick={() => setIsAnnouncementModalOpen(true)} icon={<CreateIcon />}>
            {texts.newAnnouncement}
          </PrimaryButton>
        </HeaderRow>
        <StickyToggleBar>
          <ToggleButtonGroup
            value={selectedPublishTab}
            onChange={setSelectedPublishTab}
            size="small"
            options={publishTabOptions}
          />
        </StickyToggleBar>
        <FilterAndFeedRow>
          <SidebarFilter />
          <AnnouncementList />
        </FilterAndFeedRow>
        {isAnnouncementModalOpen && (
          <AnnouncementModal isOpen={isAnnouncementModalOpen} onDidDismiss={() => setIsAnnouncementModalOpen(false)} />
        )}
      </Container>
      {!!selectedAnnouncement && (
        <FullPostView
          isOpen={!!selectedAnnouncement}
          onClose={() => updateCommentAndAnnouncementState(null, null)}
        />
      )}
      <ConfirmDialog
        isOpen={isPinConfirmOpen}
        onCancel={cancelPinReplace}
        onConfirm={confirmPinReplace}
        dialogTexts={{
          title: texts.pinReplace.title,
          content: texts.pinReplace.content,
          confirm: texts.pinReplace.confirm,
        }}
      />
    </TabContainer>
  );
};

export default Announcements;
